// extracted by mini-css-extract-plugin
module.exports = {"menuItemWrapper":"MenuItem_menuItemWrapper__2mF0d"};